import {jsx as _jsx} from "react/jsx-runtime";import {Trigger} from '@radix-ui/react-tooltip'
import {forwardRadix} from '../forwardRadix'

export const TooltipTrigger = forwardRadix(
  ({className, children, ...props}, ref) => (
    _jsx(Trigger, { ref: ref, className: className, ...props, children: 
      children
    })
  )
)
